// @flow
import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import Status from 'components/atoms/Status'

const TimeWrapper = styled.div`
  margin-bottom: ${spacing.small_2}px;
  text-align: center;
`
const Time = styled.span`
  display: block;
  color: ${Colors.gray9};
  font-size: ${fontSize.small}px;
  text-align: center;
`

type PropTypes = {
  time: string,
  statusText: any,
}

export default (props: PropTypes) => (
  <div>
    <TimeWrapper>
      <Time>{props.time}</Time>
    </TimeWrapper>
    <Status.onlyBorderFullWidthLarge>
      {props.statusText}
    </Status.onlyBorderFullWidthLarge>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/molecules/message/MessageStatus.jsx